import React from 'react';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import Header from '../components/Header';
import Footer from '../components/Footer';

const KbArticle = ({ pageContext }) => {
  const { article } = pageContext;

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{article.title} | Skillmeter Knowledge Base</title>
      </Helmet>

      <Header />

      <section className="py-12 bg-gray-50 sm:py-16 lg:py-20">
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto xl:max-w-4xl">
            <p className="text-sm font-bold text-gray-400 uppercase">
              <Link to="/kb" className="text-gray-400">Knowledge Base</Link>
              <span className="mx-2">/</span>
              {article.category}
            </p>

            <h1 className="text-3xl font-bold text-center text-gray-900 mt-7 sm:text-4xl xl:text-5xl">
              {article.title}
            </h1>

            <div className="mt-10">
              <svg className="mx-auto w-auto h-4 text-gray-300" width="172" height="16" viewBox="0 0 172 16" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                <line y1="-0.5" x2="18.0278" y2="-0.5" transform="matrix(-0.5547 0.83205 0.83205 0.5547 11 1)" />
                <line y1="-0.5" x2="18.0278" y2="-0.5" transform="matrix(-0.5547 0.83205 0.83205 0.5547 46 1)" />
                <line y1="-0.5" x2="18.0278" y2="-0.5" transform="matrix(-0.5547 0.83205 0.83205 0.5547 81 1)" />
                <line y1="-0.5" x2="18.0278" y2="-0.5" transform="matrix(-0.5547 0.83205 0.83205 0.5547 116 1)" />
                <line y1="-0.5" x2="18.0278" y2="-0.5" transform="matrix(-0.5547 0.83205 0.83205 0.5547 151 1)" />
                <line y1="-0.5" x2="18.0278" y2="-0.5" transform="matrix(-0.5547 0.83205 0.83205 0.5547 18 1)" />
                <line y1="-0.5" x2="18.0278" y2="-0.5" transform="matrix(-0.5547 0.83205 0.83205 0.5547 53 1)" />
                <line y1="-0.5" x2="18.0278" y2="-0.5" transform="matrix(-0.5547 0.83205 0.83205 0.5547 88 1)" />
                <line y1="-0.5" x2="18.0278" y2="-0.5" transform="matrix(-0.5547 0.83205 0.83205 0.5547 123 1)" />
                <line y1="-0.5" x2="18.0278" y2="-0.5" transform="matrix(-0.5547 0.83205 0.83205 0.5547 158 1)" />
              </svg>
            </div>

            <div className="mt-10 kb-content">
              <ReactMarkdown linkTarget="_blank">{article.body}</ReactMarkdown>
            </div>

            <div className="mt-12">
              <Link to="/kb" className="inline-flex items-center text-base font-medium text-smcolor hover:text-smcolor-dark">
                ← Back to Knowledge Base
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default KbArticle;
